export default {
      id: "map__car_type_paramedics-women-usage",
      viewBox: "0 0 24 26",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_paramedics-women",
      toString: function () {
        return this.url;
      }
    }